"use client";

import { App } from 'antd';
import type { ModalFuncProps } from 'antd/es/modal';

export const useModal = () => {
  const { modal } = App.useApp();

  return {
    confirm: (config: ModalFuncProps) => {
      return modal.confirm(config);
    },
    info: (config: ModalFuncProps) => {
      return modal.info(config);
    },
    success: (config: ModalFuncProps) => {
      return modal.success(config);
    },
    error: (config: ModalFuncProps) => {
      return modal.error(config);
    },
    warning: (config: ModalFuncProps) => {
      return modal.warning(config);
    },
    modal: modal
  };
};